/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type DonateHeartsControlsContainer_charity$ref: FragmentReference;
export type DonateHeartsControlsContainer_charity = {|
  +id: string,
  +image: ?string,
  +imageCaption: ?string,
  +impact: ?string,
  +name: ?string,
  +website: ?string,
  +$refType: DonateHeartsControlsContainer_charity$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "DonateHeartsControlsContainer_charity",
  "type": "Charity",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "image",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "imageCaption",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "impact",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "website",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'ebfca4dc81fb985782e3fff4d8497793';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Donate/__generated__/DonateHeartsControlsContainer_charity.graphql.js